import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

import { useActiveCollectorAgencies } from '../../hooks/useActiveCollectorAgencies';
import { LoadingSpinner } from '../LoadingSpinner';

/** Agências com dados coletados ativamente no BD (somente leitura). */
export function AgencyInterestSection() {
  const { agencies, count, isLoading } = useActiveCollectorAgencies();

  if (isLoading) {
    return <LoadingSpinner message="Carregando agências de interesse..." />;
  }

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Agências que já possuem normas monitoradas no banco, trazidas por coletores ativos (BOT, API ou
        scraping). Uma mesma fonte de coleta pode alimentar várias agências — por exemplo, o pipeline Power BI
        do MMA cobre múltiplas siglas federais.
      </Typography>

      <Typography variant="body2" sx={{ mb: 2 }}>
        <strong>{count}</strong> {count === 1 ? 'agência com coleta ativa' : 'agências com coleta ativa'}
      </Typography>

      {count > 0 ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {agencies.map((agency) => (
            <Chip
              key={agency.key}
              label={agency.name}
              size="small"
              variant="outlined"
              title={`${agency.total_normas.toLocaleString('pt-BR')} norma(s) monitorada(s)`}
            />
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Nenhuma agência com dados coletados no momento.
        </Typography>
      )}
    </Box>
  );
}
